import React, { useEffect } from "react";
import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

import { Button, Modal, Ratio } from "react-bootstrap";

const videoConstraints = {
  width: 640,
  height: 480,
  facingMode: "user",
};

function ChatPhotoPreviewModal({
  show,
  handleClose,
  onDecline,
  onSend,
  imageUrl,
  loading,
  getLangTranslation
}) {
  
  return (
    <Modal
      show={show}
      size="lg"
      className="custom-modal blur-bg"
      centered
      onHide={() => {
        handleClose();
      }}
    >
      <Modal.Header className="border-0 pb-0">
        <div className="border-0 pb-0 d-flex justify-content-between w-100">
          <h6 className="modal-title text-blue-900">{getLangTranslation("SEND_PHOTO", "Send photo")}</h6>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              handleClose();
            }}
          ></button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="ratio ratio-5x3 bg-gray">
          <img src={imageUrl} style={{objectFit: 'contain'}}/>
        </div>
        <div className="mt-6 d-flex flex-wrap justify-content-center gap-2">
          <button
            className="btn btn-outline-primary content-150 w-100"
            onClick={() => {
              onDecline();
            }}
          >
            <span className="btn-upper-case">{getLangTranslation("CANCEL", "Cancel")}</span>
          </button>

          <button className="btn btn-primary content-150 w-100 d-flex justify-content-center align-items-center gap-1" onClick={onSend}>
            <i className="icon-send fs-5" />
            <span className="btn-upper-case">{getLangTranslation("SEND", "Send")}</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ChatPhotoPreviewModal;
